"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defer = defer;
function defer() {
    const ret = {
        resolve: (_data) => {
            return;
        },
        reject: (_err) => {
            return;
        },
        promise: null,
    };
    ret.promise = new Promise((resolve, reject) => {
        ret.resolve = resolve;
        ret.reject = reject;
    });
    return ret;
}
